var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"nw",attrs:{"placeholder":_vm.$t('dashboardWidgets.note.placeholder'),"maxlength":"4000"},domProps:{"value":_vm.config.text || ''},on:{"input":_vm.onInput,"blur":_vm.flush,"mousedown":function($event){$event.stopPropagation();},"touchstart":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }